import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import Box from "@material-ui/core/Box";

const SelectOptions = ({ items, className, label, setValue, value }) => {
  return (
    <Box mr={1} className={className}>
      <Autocomplete
        size={"small"}
        style={{ minWidth: 200 }}
        options={items}
        disableClearable
        value={value}
        getOptionLabel={option => option.name}
        onChange={(event, option) => setValue(option)}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            margin="dense"
          />
        )}
        renderOption={(option, { inputValue }) => {
          const matches = match(option.name, inputValue);
          const parts = parse(option.name, matches);

          return (
            <div>
              {parts.map((part, id) => (
                <span
                  key={id}
                  style={{
                    fontWeight: part.highlight ? 700 : 400
                  }}
                >
                  {part.text}
                </span>
              ))}
            </div>
          );
        }}
      />
    </Box>
  );
};

export default SelectOptions;
